import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreditMemoApplicationRowFragment = { __typename?: 'CreditMemoApplicationDocument', applicationId: string, invoiceId: string, amount: number, appliedAt: Types.TDateISO, reversedAt?: Types.TDateISO | null };

export type CreditMemoDetailFragment = { __typename?: 'CreditMemoDocument', id: string, creditMemoId: string, creditMemoNumber: string, creditOrderId: string, creditOrderNumber: string, customerId: string, total: number, issuedAt: Types.TDateISO, amountApplied: number, amountRefunded: number, unapplied: number, applicationStatus: Types.CreditApplicationStatus, applications: Array<{ __typename?: 'CreditMemoApplicationDocument', applicationId: string, invoiceId: string, amount: number, appliedAt: Types.TDateISO, reversedAt?: Types.TDateISO | null }> };

export type IssuedCreditMemoFragment = { __typename?: 'CreditMemoStateData', creditMemoNumber: string };

export type GetCreditMemoQueryVariables = Types.Exact<{
  creditOrderId: Types.Scalars['String']['input'];
}>;


export type GetCreditMemoQuery = { __typename?: 'Query', creditMemo?: { __typename?: 'CreditMemoDocument', id: string, creditMemoId: string, creditMemoNumber: string, creditOrderId: string, creditOrderNumber: string, customerId: string, total: number, issuedAt: Types.TDateISO, amountApplied: number, amountRefunded: number, unapplied: number, applicationStatus: Types.CreditApplicationStatus, applications: Array<{ __typename?: 'CreditMemoApplicationDocument', applicationId: string, invoiceId: string, amount: number, appliedAt: Types.TDateISO, reversedAt?: Types.TDateISO | null }> } | null };

export type GetCreditMemoNumbersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCreditMemoNumbersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, creditMemo?: { __typename?: 'CreditMemoDocument', creditMemoId: string, creditMemoNumber: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const CreditMemoApplicationRowFragmentDoc = new TypedDocumentString(`
    fragment CreditMemoApplicationRow on CreditMemoApplicationDocument {
  applicationId
  invoiceId
  amount
  appliedAt
  reversedAt
}
    `, {"fragmentName":"CreditMemoApplicationRow"});
export const CreditMemoDetailFragmentDoc = new TypedDocumentString(`
    fragment CreditMemoDetail on CreditMemoDocument {
  id
  creditMemoId
  creditMemoNumber
  creditOrderId
  creditOrderNumber
  customerId
  total
  issuedAt
  applications {
    ...CreditMemoApplicationRow
  }
  amountApplied
  amountRefunded
  unapplied
  applicationStatus
}
    fragment CreditMemoApplicationRow on CreditMemoApplicationDocument {
  applicationId
  invoiceId
  amount
  appliedAt
  reversedAt
}`, {"fragmentName":"CreditMemoDetail"});
export const IssuedCreditMemoFragmentDoc = new TypedDocumentString(`
    fragment IssuedCreditMemo on CreditMemoStateData {
  creditMemoNumber
}
    `, {"fragmentName":"IssuedCreditMemo"});
export const GetCreditMemoDocument = new TypedDocumentString(`
    query GetCreditMemo($creditOrderId: String!) {
  creditMemo(creditOrderId: $creditOrderId) {
    ...CreditMemoDetail
  }
}
    fragment CreditMemoApplicationRow on CreditMemoApplicationDocument {
  applicationId
  invoiceId
  amount
  appliedAt
  reversedAt
}
fragment CreditMemoDetail on CreditMemoDocument {
  id
  creditMemoId
  creditMemoNumber
  creditOrderId
  creditOrderNumber
  customerId
  total
  issuedAt
  applications {
    ...CreditMemoApplicationRow
  }
  amountApplied
  amountRefunded
  unapplied
  applicationStatus
}`);
export const GetCreditMemoNumbersDocument = new TypedDocumentString(`
    query GetCreditMemoNumbers($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      orderId
      creditMemo {
        creditMemoId
        creditMemoNumber
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCreditMemo: build.query<GetCreditMemoQuery, GetCreditMemoQueryVariables>({
      query: (variables) => ({ document: GetCreditMemoDocument, variables })
    }),
    GetCreditMemoNumbers: build.query<GetCreditMemoNumbersQuery, GetCreditMemoNumbersQueryVariables | void>({
      query: (variables) => ({ document: GetCreditMemoNumbersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCreditMemoQuery, useLazyGetCreditMemoQuery, useGetCreditMemoNumbersQuery, useLazyGetCreditMemoNumbersQuery } = injectedRtkApi;
